const ChevronDownIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.8619 4.19525L7.99992 10.0572L2.13792 4.19525C1.87758 3.93492 1.45558 3.93492 1.19525 4.19525C0.934917 4.45558 0.934917 4.87758 1.19525 5.13792L7.52858 11.4712C7.65892 11.6016 7.82925 11.6666 7.99992 11.6666C8.17058 11.6666 8.34092 11.6016 8.47125 11.4712L14.8046 5.13792C15.0649 4.87758 15.0649 4.45558 14.8046 4.19525C14.5443 3.93492 14.1222 3.93492 13.8619 4.19525Z"
            />
        </svg>
    );
};

export default ChevronDownIcon;